import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import PasswordlessLogin from '../components/passwordlessLogin/PasswordlessLogin.container';
import TwoColumnLayout from '../layouts/TwoColumn';
import { useLoginAppDownloadBannerFlag } from '../hooks/flagsmith/useLoginAppDownloadBannerFlag';
import LoginSplash from '../components/passwordlessLogin/PasswordlessLogin.splash';
import LoginInfo from '../components/passwordlessLogin/PasswordlessLogin.info';

const LoginPage = ({ match }) => {
  useEffect(() => {
    // Don't want this to fire every time the match prop changes
    // Looks like the user loads the page 4 times for a single good login
    i18n.reloadResources();
  }, []);

  const columnOneComponent = useLoginAppDownloadBannerFlag() ? <LoginInfo /> : <LoginSplash />;

  return <TwoColumnLayout stackFirstColumn columnOneContent={columnOneComponent} columnTwoContent={<PasswordlessLogin />} height="auto" />;
};

LoginPage.propTypes = {
  match: PropTypes.shape({ url: PropTypes.string }).isRequired,
};

export default LoginPage;
